var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{inline: _vm.inline}},_vm._l((_vm.list),function(item,index){return _c('div',{key:item.label,staticClass:"radio-item",class:{active: item.active,inline: _vm.inline},on:{"click":function($event){return _vm.select(index)}}},[_vm._v(_vm._s(item.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }